/** App-shell chrome: top bar, sidebar, sync indicator, error boundaries (`components/shell/*`). */
export const shell = {
  'shell.error.title': 'Something broke.',
  'shell.error.retry': 'Retry',
  'shell.error.paneTitle': "This pane couldn't be displayed.",
  'shell.error.routeTitle': "This page couldn't be displayed.",
  'shell.error.backToNotebook': 'Back to notebook',
  'shell.error.body': 'This part of the app crashed. Your work is saved locally.',
  'shell.error.reload': 'Reload',
  'shell.error.tryAgain': 'Try again',
  'shell.error.technicalDetails': 'Technical details',

  'shell.sidebar.nav': 'Notebook',
  'shell.sidebar.favorites': 'Favorites',
  'shell.sidebar.calendar': 'Calendar',
  'shell.sidebar.chat': 'Chat',
  'shell.sidebar.settings': 'Settings',

  'shell.topbar.breadcrumb': 'Notebook',
  'shell.topbar.sidebar.show': 'Show sidebar',
  'shell.topbar.sidebar.hide': 'Hide sidebar',
  'shell.topbar.sidebar.toggleTitle': 'Toggle sidebar (Mod+\\)',
  'shell.topbar.rightPanel.show': 'Show context panel',
  'shell.topbar.rightPanel.hide': 'Hide context panel',
  'shell.topbar.rightPanel.toggleTitle': 'Toggle context panel (Mod+.)',
  'shell.topbar.theme.system': 'system',
  'shell.topbar.theme.light': 'light',
  'shell.topbar.theme.dark': 'dark',
  'shell.topbar.theme.aria': 'Theme: {theme}. Switch to {next}.',
  'shell.topbar.theme.title': 'Theme: {theme} — click for {next}',
  'shell.topbar.signOut': 'Sign out',

  'shell.sync.kind.create': 'New page',
  'shell.sync.kind.update': 'Content',
  'shell.sync.kind.move': 'Move',
  'shell.sync.kind.archive': 'Archive',
  'shell.sync.kind.restore': 'Restore',
  'shell.sync.kind.delete': 'Delete',
  'shell.sync.age.seconds': '{count}s ago',
  'shell.sync.age.minutes': '{count}m ago',
  'shell.sync.age.hours': '{count}h ago',
  'shell.sync.saved': 'Saved',
  'shell.sync.savedAt': 'Saved {time}',
  'shell.sync.nothingPending': 'Nothing pending',
  'shell.sync.saving': 'Saving…',
  'shell.sync.savingTitle': 'A write is in flight. The draft is already on this device.',
  'shell.sync.pending.one': 'Offline — {count} pending',
  'shell.sync.pending.other': 'Offline — {count} pending',
  'shell.sync.signInToSync.one': 'Sign in to sync {count} pending change.',
  'shell.sync.signInToSync.other': 'Sign in to sync {count} pending changes.',
  'shell.sync.offlineSaved': 'Saved on this device. Will sync when the server is reachable.',
  'shell.sync.offlineNotice':
    'Your changes are saved on this device and will sync when you’re back online.',
  'shell.sync.conflict': 'Conflict',
  'shell.sync.conflictTitle': 'Needs a decision. Nothing has been lost.',
  'shell.sync.empty': 'Everything is synced. Nothing is waiting.',
  'shell.sync.attempts.one': '{count} attempt',
  'shell.sync.attempts.other': '{count} attempts',
  'shell.sync.failed': 'failed',
  'shell.sync.discard': 'Discard',
  'shell.sync.retryAll': 'Retry all',
  'shell.sync.discardDialog.title': 'Discard this change?',
  'shell.sync.discardDialog.contentBody':
    'The unsaved content of “{label}” will be thrown away permanently. Copy it first if you want to keep it.',
  'shell.sync.discardDialog.genericBody': 'This change ({kind}) will be thrown away permanently.',
  'shell.sync.discardDialog.copyContent': 'Copy content',
  'shell.sync.discardDialog.copiedToast': 'Copied to the clipboard.',
  'shell.sync.discardDialog.thisPage': 'this page',

  'shell.rightPanel.aria': 'Context',
} as const;
